import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import { format, addDays } from "date-fns";
import PaymentLinkTable from "../../../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import {
  convertStraight,
  convertThenFormat,
  convertToYYYYMMDD,
  formatDateTimezon,
  currentMonthCurrentDate,
} from "../../../common-data/Converts";
import { BodyBuilder, Partial, TotalEarning } from "../../../../exports/Images";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import TEPCard from "./TEPCard";
import { fetchApiData } from "../../../../redux/reducers/commonApiSlice";
import { chartRevenueDetailNew } from "../../../../data/ApiEndpoints";
import { selectAuth, selectToken } from "../../../auth/auth.selector";
import CommonFilterStructure from "../../../common-components/CommonFilterStructure";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";

const TabViewPTRevDetail = ({ prevData, prevGymId, onCloseModal }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const user = useSelector(selectAuth);
  const { data, loading } = useSelector((state) => state.common);

  const iniTbData = {
    overallStats: {},

    fullAmountData: [],
    fullPagination: [],

    partialAmountData: [],
    partialPagination: [],

    isPage: 0,
    memberData: [],
    pagination: [],
  };
  const [memTbData, setMemTbData] = useState(iniTbData);
  const { overallStats } = memTbData || {};
  const iniAllFilters = {
    selectedStartDate: prevData
      ? convertToYYYYMMDD(prevData)
      : currentMonthCurrentDate,
    selectedEndDate: prevData
      ? convertToYYYYMMDD(prevData)
      : currentMonthCurrentDate,
    selectedTrainer: "",
    searchString: "",
    ptSubsStatus: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: memTbData.isPage + 1,
    limit: 10,
    start_date: allFilters.selectedStartDate
      ? allFilters.selectedStartDate
      : prevData,
    end_date: allFilters.selectedEndDate
      ? allFilters.selectedEndDate
      : prevData,
    gym_id: prevGymId,
    trainer_id: "",
    subscription_status: "",
    seach: "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    viewImage: "",
    partialDetails: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onCloseModalNew = (e) => {
    e.preventDefault();
    setMemTbData(iniTbData);
    onCloseModal();
  };

  const onClickReset = () => {
    setFilters(iniFilters);
    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: prevData || currentMonthCurrentDate,
      selectedEndDate: prevData || currentMonthCurrentDate,
      selectedTrainer: "",
      searchString: "",
      ptSubsStatus: "",
    }));
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  useEffect(() => {
    if (prevData) {
      setAllFilters((prevs) => ({
        ...prevs,
        selectedStartDate: prevData
          ? convertToYYYYMMDD(prevData)
          : currentMonthCurrentDate,
        selectedEndDate: prevData
          ? convertToYYYYMMDD(prevData)
          : currentMonthCurrentDate,
      }));
    }
  }, [prevData]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      start_date: allFilters.selectedStartDate
        ? allFilters.selectedStartDate
        : prevData || currentMonthCurrentDate,
      end_date: allFilters.selectedEndDate
        ? allFilters.selectedEndDate
        : prevData || currentMonthCurrentDate,
      trainer_id: allFilters.selectedTrainer?.value || "",
      subscription_status: allFilters.ptSubsStatus?.value || "",
    }));
  }, [
    memTbData.isPage,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedTrainer,
    allFilters.ptSubsStatus,
  ]);

  useEffect(() => {
    if (filters.start_date && filters.end_date) {
      dispatch(
        fetchApiData({
          method: "GET",
          endpoint: chartRevenueDetailNew,
          payload: {
            filters: filters,
          },
          token: token,
        })
      );
    }
  }, [filters]);

  useEffect(() => {
    if (data?.status) {
      const { status, full_data, partial_data, ...stats } = data || {};

      setMemTbData((prevs) => ({
        ...prevs,
        overallStats: stats,

        fullAmountData: full_data?.data || [],
        fullPagination: full_data?.pagination || [],

        partialAmountData: partial_data?.data || [],
        partialPagination: partial_data?.pagination || [],
      }));
    } else {
      setMemTbData(iniTbData);
    }
  }, [data]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  const tbColumn = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>

        // <div className="emeberDetailsRowContainer column">
        //   <p className="name minWidth150">{row?.gym_name || "N/A"}</p>
        // </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => {
        return (
          <div className="emeberDetailsRowContainer">
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "NA"}
              className="image"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  cardType: "view_image",
                  viewImage: row?.member_profile || BodyBuilder,
                }));
              }}
            />

            <div className="flexColumn" style={{ textAlign: "start" }}>
              <span className="tb-data bold" style={{ textAlign: "start" }}>
                {row?.member_name || "NA"}
                <br />
                <small
                  style={{ textTransform: "lowercase", fontWeight: "500" }}
                >
                  {row?.member_mobile || ""}
                  <br />
                  {row?.member_email || ""}
                </small>
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Price/(Online,Cash)",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            ₹{row?.price ? convertThenFormat(row.price) : 0}
            <br />
            <small style={{ fontWeight: "500" }}>
              (₹{convertThenFormat(row?.total_online || 0)} /{" "}
              {convertThenFormat(row?.total_cash || 0)})
              <br />
              {row?.plan_name || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start/Expire Date",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth200">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}{" "}
            <b>TO</b>{" "}
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info hoverBlue"
            style={{
              textDecoration: row?.is_partial === "true" ? "underline" : "",
              fontWeight: row?.is_partial === "true" ? "700" : "500",
              color: row?.is_partial === "true" ? "#5F5DF0" : "",
              cursor: row?.is_partial === "true" ? "pointer" : "default",
            }}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModalOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true"
              ? "Partial"
              : row?.is_partial === "false"
              ? "Full"
              : "NA"}
          </p>
        </div>
      ),
    },
  ];

  const tbColumnPartial = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>

        // <div className="emeberDetailsRowContainer column">
        //   <p className="name minWidth150">{row?.gym_name || "N/A"}</p>
        // </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member",
      formatter: (_, row) => {
        return (
          <div className="emeberDetailsRowContainer">
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "NA"}
              className="image"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  cardType: "view_image",
                  viewImage: row?.member_profile || BodyBuilder,
                }));
              }}
            />

            <div className="flexColumn" style={{ textAlign: "start" }}>
              <span className="tb-data bold" style={{ textAlign: "start" }}>
                {row?.member_name || "NA"}
                <br />
                <small
                  style={{ textTransform: "lowercase", fontWeight: "500" }}
                >
                  {row?.member_mobile || ""}
                  <br />
                  {row?.member_email || ""}
                </small>
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Completed/Total Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            ₹{convertThenFormat(row?.price || 0)}/
            {convertThenFormat(row?.total_price || 0)}
            <br />
            <small style={{ fontWeight: "500" }}>{row?.plan_name || ""}</small>
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online/Cash",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            ₹{convertThenFormat(row?.total_online || 0)} /{" "}
            {convertThenFormat(row?.total_cash || 0)}
          </p>
        </div>
      ),
    },
    {
      dataField: "payment_details",
      text: "Recent Payment",
      formatter: (_, row) => {
        const pendingPayments =
          row?.payment_details?.length > 0 &&
          row.payment_details.filter(
            (payment) => payment.status === "completed"
          );
        pendingPayments.sort(
          (a, b) => new Date(b.payment_created) - new Date(a.payment_created)
        );
        const recentPaymentCompleted =
          pendingPayments?.length > 0
            ? pendingPayments[0].payment_created
            : null;
        const recentPaymentCompletedAmount =
          pendingPayments?.length > 0 ? pendingPayments[0].amount : null;

        return (
          <span className="tb-data minWidth100 bold">
            <small style={{ fontWeight: "500" }}>
              ₹{convertThenFormat(recentPaymentCompletedAmount || 0)}
            </small>
            <br />
            {recentPaymentCompleted
              ? formatDateTimezon(recentPaymentCompleted)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_details",
      text: "Next Payment Due",
      formatter: (_, row) => {
        const pendingPayments =
          row?.payment_details?.length > 0 &&
          row.payment_details.filter((payment) => payment.status === "pending");
        pendingPayments.sort((a, b) => new Date(a.date) - new Date(b.date));
        const oldestPendingDate =
          pendingPayments?.length > 0 ? pendingPayments[0].date : null;
        const lastPaymentAmount =
          pendingPayments?.length > 0 ? pendingPayments[0].amount : null;

        const pendingPaymentsCount = parseInt(pendingPayments?.length || 0);

        return (
          <span
            className={`tb-data minWidth100 bold ${
              pendingPaymentsCount <= 0 ? "" : ""
            }`}
          >
            {pendingPaymentsCount <= 0 ? (
              "-"
            ) : (
              <>
                <small style={{ fontWeight: "500" }}>
                  ₹{convertThenFormat(lastPaymentAmount || 0)}
                </small>
                <br />
                {oldestPendingDate ? convertStraight(oldestPendingDate) : "-"}
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start/Expire Date",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth200">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}{" "}
            <b>TO</b>{" "}
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        const pendingPayments = row.payment_details?.filter(
          (x) => x.status === "pending"
        );
        const pendingPaymentsCount = pendingPayments?.length || 0;

        return (
          <div className="emeberDetailsRowContainer column">
            <p
              className="info hoverBlue"
              style={{
                textDecoration: row?.is_partial === "true" ? "underline" : "",
                fontWeight: row?.is_partial === "true" ? "700" : "500",
                color: row?.is_partial === "true" ? "#5F5DF0" : "",
                cursor: row?.is_partial === "true" ? "pointer" : "default",
              }}
              onClick={() =>
                row?.is_partial === "true"
                  ? setModValues((prevs) => ({
                      ...prevs,
                      isModalOpen: true,
                      cardType: "partial_details",
                      partialDetails: row?.payment_details || [],
                    }))
                  : null
              }
            >
              {row?.is_partial === "true"
                ? `Partial (${pendingPaymentsCount})`
                : row?.is_partial === "false"
                ? "Full"
                : "NA"}
            </p>
          </div>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="createNewCTOModalContainer with-react-tabs">
      <ModalHeadAndClose
        title={`PT Revenue Detail : ${prevData ? prevData : ""}`}
        onClose={onCloseModalNew}
      />

      <CommonFilterStructure
        from={"pt-revenue"}
        decryptedText={user?.user}
        setFilters={setAllFilters}
        filters={allFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        openDateRanger={openDateRanger}
        onClickReset={onClickReset}
        handleDateRangeChange={handleDateRangeChange}
        setOpenDateRanger={setOpenDateRanger}
        rangeState={rangeState}
        clearDateRanger={clearDateRanger}
        prevGymId={prevGymId}
      />

      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardType === "view_image"
              ? "discussionModalBriefContainer"
              : ""
          }`}
          style={{
            height: modValues.cardType === "view_image" ? "auto" : "",
          }}
        >
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModal}
          />
          {modValues.cardType === "view_image" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.viewImage}
                alt="member_profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="cards-container cards-grid-container threeGridSystem img-contain">
            <TEPCard
              filterType={"total_pt_revenue"}
              cardImg={TotalEarning}
              total={`₹${convertThenFormat(overallStats?.total_amount || 0)}`}
              cardTitle={"Total PT Revenue"}
              isRupee={true}
            />
            <TEPCard
              filterType={"full_partial_pt_amount"}
              cardImg={Partial}
              total={`₹${convertThenFormat(
                overallStats?.partial_amount || 0
              )}/${convertThenFormat(overallStats?.full_amount || 0)}`}
              cardTitle={"Partial/Full PT Amount"}
              isRupee={true}
            />
            <TEPCard
              filterType={"total_subscription"}
              cardImg={Partial}
              total={overallStats?.total_subscription || 0}
              cardTitle={"Total PT Subscription"}
            />
            <TEPCard
              filterType={"full_partial_pt_subscription"}
              cardImg={Partial}
              total={`${convertThenFormat(
                overallStats?.partial_subscription || 0
              )}/${convertThenFormat(overallStats?.full_subscription || 0)}`}
              cardTitle={"Partial/Full PT Subscription"}
            />
          </div>

          <Tabs>
            <TabList>
              <Tab>Full Amount</Tab>
              <Tab>Partial Amount</Tab>
            </TabList>

            <TabPanel>
              <div className="separatedTable">
                <PaymentLinkTable
                  tableData={
                    memTbData.fullAmountData?.length > 0
                      ? memTbData.fullAmountData
                      : []
                  }
                  tableColumns={tbColumn}
                  tablePagination={memTbData.fullPagination}
                  isPage={memTbData.isPage}
                  setIsPage={(value) =>
                    setMemTbData((prevs) => ({ ...prevs, isPage: value }))
                  }
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="separatedTable">
                <PaymentLinkTable
                  tableData={
                    memTbData.partialAmountData?.length > 0
                      ? memTbData.partialAmountData
                      : []
                  }
                  tableColumns={tbColumnPartial}
                  tablePagination={memTbData.partialPagination}
                  isPage={memTbData.isPage}
                  setIsPage={(value) =>
                    setMemTbData((prevs) => ({ ...prevs, isPage: value }))
                  }
                />
              </div>
            </TabPanel>
          </Tabs>
        </>
      )}
    </div>
  );
};

export default TabViewPTRevDetail;
